import { apiCallback } from 'api';

const definition = {
  service: 'slot-orchestration',
  endpoint: 'slot-dates',
  verbs: ['get'],
  defaultVersion: '1',
  query: {
    addressId: '${addressId}',
    branchId: '${branchId}',
    customerOrderId: '${customerOrderId}',
    fromDate: '${fromDate}',
    size: '${size}',
    slotType: '${slotType}',
  },
};

export const getSlotDates = apiCallback(definition, 'get');
